// assets/pdp-ajax.js
// Improved PDP color swatch AJAX handler for Triumph theme

(function() {
  // Re-executes inline scripts within an element.
  function executeScripts(element) {
    element.querySelectorAll('script:not([src])').forEach((oldScript) => {
      const newScript = document.createElement('script');
      Array.from(oldScript.attributes).forEach((attr) => {
        newScript.setAttribute(attr.name, attr.value);
      });
      newScript.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  document.addEventListener('click', async (event) => {
    // Adapted selector: PDP swatch button (not in modal)
    const swatchButton = event.target.closest('.color-swatch-label[data-product-url]');
    if (!swatchButton) return;
    // If inside a modal, ignore (modal swatches handled elsewhere)
    if (swatchButton.closest('.quick-add-modal, quick-add-modal')) return;
    // Skip if already selected
    if (swatchButton.classList.contains('selected')) return;

    const productUrl = swatchButton.dataset.productUrl;
    const section = document.querySelector('section[id^="MainProduct-"]');
    if (!productUrl || !section) {
      window.location.href = productUrl;
      return;
    }

    // Show loading state
    section.classList.add('main-product-loading');

    const sectionId = section.id.replace('MainProduct-', '');

    try {
      // Fetch only the main product section for efficiency
      const response = await fetch(`${productUrl}?section_id=${sectionId}`);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newSection = doc.querySelector('section[id^="MainProduct-"]');

      if (!newSection) throw new Error('Main product section not found');

      section.replaceWith(newSection);
      // Re-execute inline scripts (for payment, widgets, etc.)
      executeScripts(newSection);
      // Reinitialize Shopify payment buttons if present
      if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') {
        window.Shopify.PaymentButton.init();
      }
      // Optionally: update URL in browser history
      window.history.replaceState({}, '', productUrl);
      // Optionally: re-initialize any PDP scripts
      if (window.initPDPSection) window.initPDPSection();
    } catch (error) {
      console.error('Color swatch AJAX error:', error);
      window.location.href = productUrl;
    }
  });
})();
